import classNames from 'classnames';
import React, { memo } from 'react';

type Props = {
  sectionId: string;
  icon?: any;
  text: string;
  className?: string;
  textClassName?: string;
};

const SectionScroll = ({ sectionId, icon, text, className = '', textClassName = '' }: Props) => {
  return (
    <a
      href={`#${sectionId}`}
      className={classNames(
        'tw-flex tw-items-center tw-gap-2 tw-font-medium tw-text-body tw-transition tw-duration-200 hover:tw-text-body hover:!tw-no-underline hover:tw-opacity-75',
        className
      )}>
      {!!icon && icon} <span className={classNames('tw-text-sm', textClassName)}>{text}</span>
    </a>
  );
};

export default memo(SectionScroll);
